import Vue from 'vue'
import Vuex from 'vuex'
import _ from 'lodash'

import { API_AD } from '@/axios'

Vue.use(Vuex)

export const store = Vue.observable({
  isNavOpen: false
})

export const mutations = {
  setIsNavOpe (yesno) {
    store.isNavOpen = yesno
  },
  toggleNav () {
    store.isNavOpen = !store.isNavOpen
  }
}

export default new Vuex.Store({
  strict: true,

  state: {
    product_data: [],
    products_list_shelf: [],
    magazyn: [],
    loading: false,
    scaned: ''
  },

  getters: {
    magazynByIm: (state) => (imagazyn) => {
      return state.magazyn.find(arr => arr.imagazyn === imagazyn)
    }
  },

  actions: {
    getProduct ({commit, dispatch}) {
      commit('changeLoadingState', true)
      API_AD.get(`global_get_product_info_by_sku/` + this.state.scaned, {withCredentials: true})
        .then(
          (response) => {
            commit('updateProduct', response.data)
          },
          (error) => {
            console.log(error)
          }
        )
        .finally(
          () => {
            dispatch('prepareMagazyn')
            commit('changeLoadingState', false)
          }
        )
    },
    getProductsListByShelf ({commit, dispatch}) {
      commit('changeLoadingState', true)
      API_AD.get(`adaptix_get_products_list_by_shelf/` + this.state.scaned, {withCredentials: false})
        .then(
          (response) => {
            commit('updateProductsListByShelf', response.data)
          },
          (error) => {
            console.log(error)
          }
        )
        .finally(
          () => {
            commit('changeLoadingState', false)
          }
        )
    },
    prepareMagazyn ({commit}) {
      let stany = this.state.product_data.data.soap_adaptix.Vindeks_data.Vstan_magazynu
      let stanyNull = {
        imagazyn: '',
        stan: '0',
        zostalo: '0'
      }
      let stanyMg = _.find(stany, {imagazyn: 'MG'}) || stanyNull
      let stanyMgw = _.find(stany, {imagazyn: 'MGW'}) || stanyNull
      let stanyAdd = {
        imagazyn: 'MG+MGW',
        stan: String(Number(stanyMg.stan) + Number(stanyMgw.stan)),
        zostalo: String(Number(stanyMg.zostalo) + Number(stanyMgw.zostalo))
      }
      // console.log(stanyAdd)
      if (Array.isArray(stany) === true) {
      } else {
        stany = [stany]
      }
      if (_.find(stany, {imagazyn: 'MG'}) && _.find(stany, {imagazyn: 'MGW'})) {
        stany.push(stanyAdd)
      }
      stany = _.orderBy(stany, ['imagazyn'])
      commit('updateMagazyn', stany)
    },
    updateAdaptixShelf (context, payload) {
      return new Promise((resolve, reject) => {
        context.commit('changeLoadingState', true)
        let iindeksy = this.state.product_data.data.soap_adaptix.Vindeks_data.iindeksy
        let vpropertUpdate = {'ipropert': payload.ipropert, 'ipropers': payload.newValue}
        let postData = {
          'iindeksy': iindeksy,
          'Vpropert_update': vpropertUpdate
        }
        const headers = {
          // 'Content-Type': 'application/x-www-form-urlencoded'
          // 'Content-Type': 'application/json'
        }
        API_AD.post('aw_indeks_update', postData, {headers})
          .then(
            res => {
              // console.log(res.data)
              this.emessage = res.data.answer.emessage || 'ERROR'
              this.detail = res.data.answer.detail || 'Success'
              this.detail = this.detail.errormessage || 'Success'
            }
          )
          .finally(
            () => {
              if (this.emessage === 'OK') {
                context.commit('updateShelf', postData)
              }
              resolve({'emessage': this.emessage, 'detail': this.detail})
              context.commit('changeLoadingState', false)
            }
          )
      })
    }
  },

  mutations: {
    updateProduct (state, payLoad) {
      state.product_data = payLoad
    },
    updateProductsListByShelf (state, payLoad) {
      state.products_list_shelf = payLoad.data
    },
    changeLoadingState (state, status) {
      state.loading = status
    },
    updateScaned (state, payLoad) {
      state.scaned = payLoad.scaned
    },
    updateMagazyn (state, payLoad) {
      state.magazyn = payLoad
    },
    updateShelf (state, payLoad) {
      const ipropert = payLoad.Vpropert_update.ipropert
      const ipropers = payLoad.Vpropert_update.ipropers
      switch (ipropert) {
        case 'pólka1':
          state.product_data.generated.pólka1 = ipropers
          break
        case 'półka3':
          state.product_data.generated.półka3 = ipropers
          break
        case 'regał':
          state.product_data.generated.regał = ipropers
          break
        case 'regał2':
          state.product_data.generated.regał2 = ipropers
          break
        case 'regał3':
          state.product_data.generated.regał3 = ipropers
          break
      }
    }
  },

  modules: {
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js